__turbopack_context__.v({
  "dropdown": "IC0RLW_dropdown",
  "dropdown__input": "IC0RLW_dropdown__input",
  "dropdown__input__icon": "IC0RLW_dropdown__input__icon",
  "dropdown__input__text": "IC0RLW_dropdown__input__text",
  "dropdown__options": "IC0RLW_dropdown__options",
  "dropdown__options__list": "IC0RLW_dropdown__options__list",
  "dropdown__options__list__option": "IC0RLW_dropdown__options__list__option",
  "dropdown__options__search": "IC0RLW_dropdown__options__search",
  "wrapper": "IC0RLW_wrapper",
});
